import axios from '../../utils/http/http';
import { triggerNotification } from '../../utils/NotificationContext';

export const fetchCurrentCycle = async (businessUnitName) => {
  try {
    const response = await axios.getRequest(
      `/tpo/getRanCycleList?businessUnitName=${encodeURIComponent(businessUnitName)}`
    );

    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

/**api to check if the user is logging in 1st time */
export const fetchLastLoginDetails = async (email, payload) => {
  try {
    let url = '/tpo/landing/updateUserDetailsAndRole/' + email;
    const response = await axios.postRequest(url, payload);

    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get user details!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const fetchAllMembers = async (buName, teamName) => {
  try {
    const response = await axios.getRequest(
      `/tpo/team/getAllMembers/${encodeURIComponent(buName)}?teamName=${teamName}`
    );
    return response;
  } catch (error) {
    console.log('Error Found: fetchAllMembers -> error', error);
    throw error;
  }
};

export const fetchTaskList = async () => {
  try {
    const response = await axios.getRequest(`/tpo/task/taskList`);
    return response;
  } catch (error) {
    console.log('Error Found: fetchTaskList -> error', error);
    throw error;
  }
};

export const fetchUserDetail = async (userEmail, buName) => {
  try {
    const response = await axios.getRequest(`/tpo/user/getUserDetail/${userEmail}/${encodeURIComponent(buName)}`);
    return response;
  } catch (error) {
    console.log('Error Found: fetchUserDetail -> error', error);
    throw error;
  }
};

export const fetchNotifications = async (userId, buName) => {
  try {
    const response = await axios.getRequest(
      `/tpo/user/getListNotification/${userId}/${encodeURIComponent(buName)}?version=v2`
    );
    return response;
  } catch (error) {
    console.log('Error Found: fetchNotifications -> error', error);
    throw error;
  }
};

export const changeReadFlag = async (payload) => {
  try {
    const response = await axios.postRequest(
      `/tpo/user/updateNotificationFlag?version=v2`,
      payload
    );
    return response;
  } catch (error) {
    console.log('Error Found: changeReadFlag -> error', error);
    throw error;
  }
};

export const fetchListOfActiveBUs = async () => {
  try {
    const response = await axios.getRequest(`/tpo/landing/getListOfActiveBUs`);
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const fetchUserDetails = async (email) => {
  try {
    const response = await axios.getRequest(`/tpo/landing/getUserDetails/${email}`);
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to get data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};
